import { render, staticRenderFns } from "./PushNotificationModal.vue?vue&type=template&id=1220a42c&scoped=true&"
import script from "./PushNotificationModal.vue?vue&type=script&lang=js&"
export * from "./PushNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1220a42c",
  null
  
)

export default component.exports